import { Card } from "antd";
import Image2 from "../../../../assets/images/measurement-Image2.png";
import "../style.scss";

const DigitalTwinCard = (props: any) => {
  return (
    <Card className="graph-view-container">
      <div className="mb-4">
        <img
          src={Image2}
          alt="Measurement Graph"
          className="graph-view-image"
        />
      </div>
      <div className="mb-3">
        <div className="card-heading2 mb-1">D-Twin ID</div>
        <div className="digital-twin-id">{props?.id}</div>
      </div>
      <div className="mb-3">
        <div className="card-heading2 mb-1">Display Name</div>
        <div className="card-text2">HSG-2011-M04</div>
      </div>
      <div>
        <div className="card-heading2 mb-1">Description</div>
        <div className="card-text2">
          The captured sensor information is displayed here. It provides users
          with all relevant measurements surrounding the alert date, allowing
          for detailed analysis of system performance, potential issues and
          recommended actions
        </div>
      </div>
    </Card>
  );
};

export default DigitalTwinCard;
